import styled from "styled-components";

export default styled.div`
  height:auto;
  width: 100%;
  background-color: #fff;
  margin: 0px;
  margin-left:20px;
`;
